let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("Z1uIk")).then(() => parcelRequire('5PcPr'));